import { StateReducers } from '../reducers/types/StateReducers'

interface Props {
  state: StateReducers
}

export const getIsTouchScreen = ({ state }: Props): boolean => {
  return !!state?.windowMeta?.isTouch
}
